import { View } from 'react-native';
import lang from '@components/modals/LanguageModal/constant/languageList';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';

export const FlagHandler = () => {
  const activeLanguage = useSelector((state: DefaultRootState) => state.app.language.value)

  const langList = lang;

  const ActiveFlag = useCallback(() => {
    const matchingLang = langList.find(langItem => langItem.value === activeLanguage);
    
    if (matchingLang) {
      return (
        <View style={{ flex: 1 }} key={matchingLang.languageCode}>
          {matchingLang.source}
        </View>
      );
    }
    
    // Default to first language if no match found
    return (
      <View style={{ flex: 1 }} key={langList[0].languageCode}>
        {langList[0].source}
      </View>
    );
  }, [activeLanguage, langList])

  return (
    <View style={{ flex: 1, justifyContent: 'center' }}>
      <ActiveFlag />
    </View>
  )
}

export default FlagHandler;
